<template>
  <!--   bottom: 155px;
  right: 15px; -->
  <div class="autoMatic_box" ref="autoBox" :style="{'bottom':fix_size?'155px':'null','right':fix_size?'15px':'null','left':fix_size?'null':posLeft+'px','top':fix_size?'null':posTop+'px'}" v-if="sonIncan">
    <!--    <div class="autoMatic_box">-->
    <!--    <div class="box_center" v-loading="incan_load">-->
<!--    <div class="box_center">-->
    <div class="jiantou" v-show="sonIncan&&rou_url"></div>
      <div :class="['box_center',rou_url?'animate-popup2':'animate-popup1']" ref="centerBox" v-if="sonIncan">
      <div class="box_header">
        <div>
          优化后的提示词
        </div>
        <img src="@/components/images/lingganImg/close.png" class="close_img" alt="" @click="sonIncan = false">
      </div>
      <div :class="['boxBody','boxBody1']">
        <!-- <div class="box_body">
          <div class="font_title">
            <div class="china_title" style="margin-bottom:14px ">
              {{ incan_list[0].zh }}
            </div>
          </div>
          <div class="box_footer">
            <div class="foot_btn1" @click="deactivateAll('operate1',0)">
              继续使用<img src="./img/icon_img36.png" alt=" "/>
            </div>
          </div>
        </div>
        <div class="system_box">
          <div>
            系统优化提示词
            <span>建议使用下方提示词，绘图质量更高</span>
          </div>
          <span>下方提示词可以修改</span>
        </div> -->
        <div class="box_body" v-if="index!=0" v-for="(item, index) in incan_list">
          <div v-if="!incan_load">
            <!--            <div v-if="false">-->
            <div class="font_title">
              <div class="china_title cn_inp" v-if="!item.more" @click="activateEdit(index)">
                {{ item.zh }}
              </div>
              <div class="text_inp">
              <textarea ref="textareaRefs"
                        v-model="item.zh" @blur="deactivateAll"
                        v-show="item.more" rows="3"></textarea>
              </div>
              <div class="english_title">
                {{ item.en }}
              </div>
            </div>
            <div class="box_footer">
              <div :class="['foot_btn3',index==1?'btn3_1':'btn3_2']">
                {{ index == 1 ? '基础版' : '进阶版' }}
              </div>
              <div class="foot_btn2" @click="deactivateAll('operate2',index)">
                使用它<img src="./img/icon_img36.png" alt=" "/>
              </div>
            </div>
          </div>
          <div v-else class="load_gif">
            <!--            <div class="load_gif">-->
            <img src="./img/AipromptWords.gif" alt="">
            <span>
              系统正在为您优化......{{ percentage }}%
            </span>
          </div>

          <div class="xuxian" v-if="index==1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">

export default {
  props: ['typedata', 'inpdata','fix_size'],
  data() {
    return {
      sonIncan: false, // 优化咒语
      incan_load: false, //
      incan_list: [
        {zh: '', en: '', more: false,},
        {zh: '', en: '', more: false,},
        {zh: '', en: '', more: false,},
      ], // 优化咒语列表
      textareaRefs: [],
      percentage: 1,  // 初始1%
      remainingTime: 10,
      interval: null,
      time: null,
      rou_url:false,
      posLeft: null,
      posTop: null,
    }
  },
  created() {

  },
  methods: {
    updatePosition() {
      this.$nextTick(() => {
        const target = document.querySelector('#only_desc');
        const centerBox = this.$refs.centerBox;
        if (!target || !centerBox) return;
        const rect = target.getBoundingClientRect();
        // 使用未受 transform 影响的高度，避免动画期间测量异常
        const boxHeight = centerBox.offsetHeight || 0;

        const left = Math.round(rect.right + 20);
        const top = Math.max(10, Math.round(rect.top + rect.height / 2 - boxHeight / 2));
        this.posLeft = left;
        this.posTop = top;
      });
    },
    hide_box(){
      this._boundHandleGlobalClick = this.handleGlobalClick.bind(this);
      window.addEventListener('click', this._boundHandleGlobalClick, true);
    },
    handleGlobalClick(e) {
      if(!this.sonIncan) return
      const searchWrap = this.$refs.autoBox;
      const target = e.target;
      // 如果点击发生在搜索区域内，则不关闭
      const inSearchArea = (searchWrap && (searchWrap === target || searchWrap.contains(target)));
      if (inSearchArea) return;
      this.sonIncan = false
    },
    show(type) {

      let rouUrl = this.$route.path
      console.log('this.$route',rouUrl);
      if(rouUrl=='/mj'||rouUrl=='/dallE3'){
        this.rou_url = false
      }else{
        this.rou_url = true
      }

      if (type == true) {
        this.sonIncan = true
        this.hide_box()
        if(!this.fix_size){
          this.updatePosition();
          // 动画结束后再校准一次，避免动画中的 transform 影响尺寸
          this.$nextTick(() => {
            const center = this.$refs.centerBox;
            if (center) {
              center.addEventListener('animationend', this.updatePosition, { once: true });
            }
          });
        }
        this.deactivateAll('post')
      } else {
        this.sonIncan = false
        this.incan_list = [
          {zh: '', en: '', more: false,},
          {zh: '', en: '', more: false,},
          {zh: '', en: '', more: false,},
        ]
      }

    },
    activateEdit(index) {
      // 先关闭所有编辑框
      // 打开当前项的编辑状态
      console.log('index', index)
      this.incan_list.forEach((item, i) => {
        if (index == i) {
          console.log('true')
          item.more = true
          this.$nextTick(() => {
            this.$refs.textareaRefs[index - 1].focus();
          });
        } else {
          console.log('false')
          item.more = false
        }
      });
      // 等待DOM更新后聚焦
      console.log('textareaRefs', this.$refs.textareaRefs)

    },
    deactivateAll(type, index) {
      if (type === 'operate1' || type === 'operate2') {
        console.log('this.typedata', this.typedata)
        this.$emit('getPromptData1', this.incan_list[index].zh.trim())
      } else if (type === 'post') {
        this.incan_list = [
          {zh: this.inpdata, en: '', more: false},
          {zh: '', en: '', more: false},
          {zh: '', en: '', more: false}
        ];
        this.sonIncan = true
        this.incan_load = true
        this.opentimer()
        if(!this.fix_size){
          // 进入加载态时先按加载态高度定位一次
          this.$nextTick(() => this.updatePosition());
        }
        console.log(1111111111)
        this.$http.post('/front/aimj/draw/prompt/',
            {question: this.inpdata, type: this.typedata,}).then((res) => {
          this.incan_load = false
          if (res.status == 200) {
            this.incan_list = [
              {zh: this.inpdata, en: '', more: false},
              {zh: res.data.higt1.zh, en: res.data.higt1.en, more: false},
              {zh: res.data.higt2.zh, en: res.data.higt2.en, more: false}
            ];
            console.log(this.incan_list)
            this.stopTimer()
            this.percentage = 0
            if(!this.fix_size){
              // 数据渲染完成后再定位一次，确保最终位置一致
              this.$nextTick(() => this.updatePosition());
            }
          } else {
            console.log('失败')
            this.$message.error("你提交的内容涉及敏感信息,请修改后重新提交！")
            this.incan_load = false
            this.sonIncan = false
          }
        }).catch((err) => {
          console.log('失败err', err)
          this.$message.error(err.message)
          this.incan_load = false
          this.sonIncan = false
        })
      } else {
        this.incan_list.forEach((e, i) => {
          e.more = false
        });
      }
      this.percentage=1
    },
    opentimer() {
      // 更新剩余时间
      this.interval = setInterval(() => {
        this.remainingTime--;
        if (this.remainingTime <= 0 && this.percentage >= 99) {
          this.stopTimer()
        }
      }, 1000);

      // 更新随机百分比
      this.timer = setInterval(() => {
        this.percentage += Math.floor(Math.random() * 5) + 1;
        if (this.percentage >= 99) {
          this.percentage = 99
        }
      }, 500); // 每300毫秒更新一次随机值
    },
    stopTimer() {
      clearInterval(this.timer);
      clearInterval(this.interval);
    },

  },
};


</script>
<style rel="stylesheet/scss" lang="scss" scoped>
// 自动优化
.autoMatic_box {
  // width: 100%;
  // height: 100%;
  position: fixed;

  // background-color: rgba(0, 0, 0, 0.8);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  font-weight: 400;
  line-height: 1.4;
  .jiantou{
    //左箭头
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 9px solid transparent;
    border-bottom: 9px solid transparent;
    border-right: 9px solid #10151f;
    z-index: 1;
  }
  .box_center {
    //position: absolute;
    //left: 50%;
    //top: 50%;
    //transform: translate(-50%, -50%);
    width: 550px;
    border-radius: 10px;
    border: 2px solid #5865f2;
    background-color: #000;
    overflow: hidden;
    &.animate-popup1 {
      animation: scaleIn1 0.5s ease-out;
    }
    &.animate-popup2 {
      animation: scaleIn2 0.5s ease-out;
    }
    @keyframes scaleIn1 {
      0% {
        transform: translate(100%, 100%) scale(0); /* 从右下角开始 */

        //opacity: 0;
      }
      100% {
        transform: translate(0, 0) scale(1); /* 移动到中间 */

        //opacity: 1;
      }
    }
    @keyframes scaleIn2 {
      0% {
        // transform: translate(0, 0) scale(1); /* 从右下角开始 */

        opacity: 0;
      }
      100% {
        transform: translate(0, 0) scale(1); /* 移动到中间 */

        opacity: 1;
      }
    }

    .box_header {
      background-color: #5865f2;
      padding: 10px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 700;
      .close_img{
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    

    .boxBody {
      overflow: auto;

      .box_body {
        font-size: 14px;
        padding: 0 14px;
        margin: 14px 0;

        .load_gif {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          img {
            width: 150px;
          }

          span {
            margin-bottom: 10px;
          }
        }

        .font_title {
          line-height: 1.2;

          .china_title {
            //display: -webkit-box;
            //-webkit-line-clamp: 3;  /* 限制为3行 */
            //-webkit-box-orient: vertical;
            //overflow: hidden;
            //text-overflow: ellipsis;
            line-height: 1.6;
            color: #aaa;

            &.cn_inp {
              cursor: pointer;
            }
          }

          .english_title {
            //display: -webkit-box;
            //-webkit-line-clamp: 3;  /* 限制为3行 */
            //-webkit-box-orient: vertical;
            //overflow: hidden;
            //text-overflow: ellipsis;
            line-height: 1.4;
            word-break: break-all;
            color: #997a48;
            margin: 14px 0;
          }

          .text_inp {
            textarea {
              width: 100%;
              padding: 5px 8px;
              border-radius: 4px;
              border: 2px solid #5865f2;
            }
          }
        }

        .box_footer {
          display: flex;
          justify-content: flex-end;

          .foot_btn1, .foot_btn2, .foot_btn3 {
            cursor: pointer;
            color: #fff;
            font-size: 14px;
            width: 110px;
            padding: 10px 14px;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;

            img {
              width: 12px;
              height: 12px;
              margin-left: 4px;
            }
          }

          .foot_btn1 {
            background-color: #5865f2;

          }

          .foot_btn2 {
            background-color: #997a48;
          }

          .foot_btn3 {
            width: 95px;
            margin-right: 10px;
            background-color: #333333;
            cursor: auto;

            &.btn3_1 {
              color: #999;

            }

            &.btn3_2 {
              color: #997a48;
            }
          }

        }

        .xuxian {
          width: 100%;
          border-top: 1px dashed #666666;
          margin-top: 14px;
        }
      }
    }

    .system_box {
      background-color: #333333;
      padding: 10px 10px;
      color: white;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 700;

      span {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}

/* 当屏幕高度在900-1100px范围内时应用 */
@media screen and (min-height: 0) and (max-height: 600px) {
  .boxBody1 {
    min-height: 500px;
    max-height: 500px;
  }
}

@media screen and (min-height: 600px) and (max-height: 700px) {
  .boxBody1 {
    min-height: 550px;
    max-height: 600px;
  }
}

@media screen and (min-height: 700px) and (max-height: 800px) {
  .boxBody1 {
    min-height: 550px;
    max-height: 650px;
  }
}

@media screen and (min-height: 800px) {
  .boxBody1 {
    // min-height: 550px;
    max-height: 600px;
  }
}

</style>